import React from 'react';

import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import Loader from 'components/Loader';
import ManagePageHeader from 'components/ManagePageHeader/ManagePageHeader';
import { actionTemplatesApi } from 'config/api/actionLibrary/actionLibrary';
import { parseActionTemplateForForm } from 'config/api/actionLibrary/actionLibrary.parsers';
import action_library_messages from 'messages/action_library_messages';

import ActionTemplateForm from '../ActionLibraryCreatePage/ActionTemplateForm';
import useActionTemplateFormManager from '../ActionLibraryCreatePage/useActionTemplateFormManager';

const ActionLibraryEditPage: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const { data, isLoading } = useQuery(['actionTemplate', id], () => actionTemplatesApi.getSingleActionTemplate(Number(id)));

  const { setIsDirty, saveHandlerRef, handleNavigation, NavigationPrompt } = useActionTemplateFormManager({
    isEditMode: true,
    templateId: Number(id),
  });

  if (isLoading || !data) {
    return <Loader inner />;
  }

  const initialValues = parseActionTemplateForForm(data.data);

  return (
    <Container>
      <NavigationPrompt />
      <ManagePageHeader backButton onBack={handleNavigation} subtitle={t(action_library_messages.edit_subtitle)}>
        {t(action_library_messages.actions.edit)}
      </ManagePageHeader>
      <ActionTemplateForm
        initialValues={initialValues}
        isEditMode
        onCancelNavigation={handleNavigation}
        onDirtyStateChange={setIsDirty}
        onSaveRequestRef={saveHandlerRef}
        templateId={Number(id)}
      />
    </Container>
  );
};

export default ActionLibraryEditPage;
